"use client";

import { useEffect } from "react";

/**
 * Sets html[data-footer-visible="on"] while the site footer is on screen, so
 * the floating chat button can step aside instead of covering footer links
 * (audit 3.1). The rules live in globals.css next to .fab-lift.
 */
export function FloatingUiGuard(): null {
  useEffect(() => {
    const footer = document.querySelector("footer");
    if (!footer || typeof IntersectionObserver === "undefined") return;
    const root = document.documentElement;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) root.dataset.footerVisible = "on";
        else delete root.dataset.footerVisible;
      },
      { threshold: 0 },
    );
    io.observe(footer);
    return () => {
      io.disconnect();
      delete root.dataset.footerVisible;
    };
  }, []);
  return null;
}
